import { NavLink, useLocation } from 'react-router-dom';
import { LayoutDashboard, Dumbbell, UtensilsCrossed, Pill, TrendingUp, Settings } from 'lucide-react';

const navItems = [
  { path: '/', icon: LayoutDashboard, label: 'Dashboard' },
  { path: '/training', icon: Dumbbell, label: 'Training' },
  { path: '/meals', icon: UtensilsCrossed, label: 'Meals' },
  { path: '/supps', icon: Pill, label: 'Supps' },
  { path: '/progress', icon: TrendingUp, label: 'Progress' },
];

export const Layout = ({ children }) => {
  const location = useLocation();
  const isSettings = location.pathname === '/settings';

  return (
    <div className="min-h-screen bg-[#1a1a2e] text-white pb-20 safe-area-bottom">
      <main className="px-4 pt-4 pb-24 max-w-lg mx-auto">
        {children}
      </main>
      
      {/* Bottom Navigation */}
      <nav 
        className="fixed bottom-0 left-0 right-0 bg-[#1a1a2e]/95 backdrop-blur-lg border-t border-white/5 safe-area-bottom z-50"
        data-testid="bottom-nav"
      >
        <div className="flex justify-around items-center h-16 max-w-lg mx-auto px-2">
          {navItems.map(({ path, icon: Icon, label }) => (
            <NavLink
              key={path}
              to={path}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center w-14 h-14 rounded-xl transition-all duration-200 ${
                  isActive && !isSettings
                    ? 'text-[#00E676] bg-[#00E676]/10'
                    : 'text-gray-500 hover:text-gray-300'
                }`
              }
              data-testid={`nav-${label.toLowerCase()}`}
            >
              <Icon size={22} strokeWidth={2} />
              <span className="text-[10px] font-bold uppercase tracking-wider mt-1">{label}</span>
            </NavLink>
          ))}
          <NavLink
            to="/settings"
            className={({ isActive }) =>
              `flex flex-col items-center justify-center w-14 h-14 rounded-xl transition-all duration-200 ${
                isActive
                  ? 'text-[#00E676] bg-[#00E676]/10'
                  : 'text-gray-500 hover:text-gray-300'
              }`
            }
            data-testid="nav-settings"
          >
            <Settings size={22} strokeWidth={2} />
            <span className="text-[10px] font-bold uppercase tracking-wider mt-1">Settings</span>
          </NavLink>
        </div>
      </nav>
    </div>
  );
};
